
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "academy-achievements-public-ui",
  currentProjectVersion: "static-1.1116",
  depVersions: {
  "academy-achievements-public-ui": "static-1.1116",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.512",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8542",
  "hubspot-dlb": "static-2.1911",
  "react-dlb": "static-1.96",
  "academy-ai-assistant-lib": "static-1.1722",
  "academy-common-lib": "static-1.15552",
  "academy-navigation-lib": "static-1.2655",
  "analytics_js": "static-1.4512",
  "apollo-stack-hubspot": "static-3.94",
  "avatar-components": "static-1.2991",
  "classnames": "static-2.10",
  "data-fetching-client": "static-1.10141",
  "enviro": "static-4.523",
  "foundations-assets": "static-1.5393",
  "foundations-components": "static-1.8792",
  "foundations-theming": "static-1.4993",
  "graphql": "static-1.95",
  "hub-http": "static-1.6709",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11991",
  "I18n": "static-7.1715",
  "quartz": "static-1.7694",
  "quartz-config": "static-1.1472",
  "quartz-core": "static-1.6913",
  "quartz-routing": "static-1.1124",
  "quartz-tracking": "static-1.1073",
  "raven": "static-3.6411",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17242",
  "rpc-client-utils": "static-1.5169",
  "signup-constants": "static-1.19995",
  "styled-components": "static-2.100",
  "trellis-ecosystem": "static-1.7892",
  "ui-addon-i18n": "static-1.11648",
  "UIComponents": "static-3.8937",
  "viral-links-lib": "static-1.7586",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3971",
  "quartz-webpack": "static-1.3918",
  "bend-plugin-quartz-routing": "static-1.772",
  "HeadJS": "static-2.829",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3653",
  "msw": "static-1.105",
  "msw-config": "static-1.35",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "ai-components-ui-library": "static-1.10071",
  "ai-rendering-library": "static-1.11451",
  "breeze-engine-core": "static-1.1545",
  "breeze-engine-chat-components": "static-1.1245",
  "breeze-engine-lib": "static-1.2267",
  "copilot-toolkit": "static-1.12201",
  "hs-lodash": "static-4.45",
  "magpie-lib": "static-1.5932",
  "navigation-components": "static-1.19221",
  "nest": "static-1.740",
  "pulse": "static-1.1154",
  "storybook-react": "static-1.46",
  "ts-schema": "static-1.4409",
  "zustand": "static-1.91",
  "academy-service-client": "static-1.4195",
  "croppie": "static-2.10",
  "cssUtils": "static-1.1125",
  "feedback-loader": "static-1.30102",
  "FileManagerCore": "static-1.40385",
  "FileManagerLib": "static-1.40526",
  "final-form": "static-1.85",
  "foundations-components-legacy": "static-1.1817",
  "foundations-theming-specialty": "static-1.2709",
  "hs-story-utils": "static-1.9931",
  "HubStyle": "static-2.12298",
  "icons": "static-2.709",
  "immer": "static-1.107",
  "markdown-it": "static-1.6",
  "navigation-messaging": "static-1.8548",
  "onboarding-tours": "static-1.17430",
  "PatternValidationJS": "static-1.3385",
  "quick-fetch": "static-1.4245",
  "react-utils": "static-2.5681",
  "SafeStorage": "static-1.4898",
  "sanitize-text": "static-1.8661",
  "sassPrefix": "static-1.390",
  "SharedI18nStrings": "static-1.190",
  "StyleGuideUI": "static-3.520",
  "ui-addon-react-router-dom": "static-1.10028",
  "ui-addon-video-player": "static-1.9126",
  "ui-fonts": "static-1.1253",
  "ui-images": "static-2.1283",
  "usage-tracker-container": "static-1.7815",
  "usage-tracker-core": "static-1.7675",
  "video-embed": "static-1.36986",
  "wootric-nps": "static-1.7312",
  "hub-http-janus": "static-1.913",
  "hub-http-shared-msw-handlers": "static-1.10949",
  "hubspotter-http": "static-1.4989",
  "trellis-components": "static-1.3179",
  "trellis-migration-context": "static-1.81",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5061",
  "floating-ui": "static-1.70",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.111",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3160",
  "bend-plugin-foundations-theming": "static-1.3476",
  "foundations-theming-base": "static-1.3978",
  "stylex": "static-1.48",
  "hs-locale-management": "static-1.416",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4809",
  "jasmine-runner": "static-1.6956",
  "opentelemetry-fe-types": "static-1.295",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.670",
  "quartz-auth": "static-1.1369",
  "quartz-head": "static-1.1359",
  "quartz-i18n": "static-1.1369",
  "quartz-test": "static-1.1369",
  "usage-tracker-session-replay": "static-1.5511",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.202",
  "web-vitals": "static-1.21",
  "bend-plugin-chirp-manifest": "static-1.579",
  "chirp-fetch": "static-1.2408",
  "marketplace-ui-apps-core": "static-1.19610",
  "marketplace-ui-common": "static-1.21078",
  "trellis-story-utils": "static-1.5002",
  "foundations-components-test-utils": "static-1.6275",
  "react-input-autosize": "static-2.17",
  "signup-ui-url-generator": "static-2.8541",
  "bender-build-tools": "static-1.3617",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24046",
  "ContentUtils": "static-1.69538",
  "customer-data-objects-ui-components": "static-1.13539",
  "sanitize": "static-1.4973",
  "breeze-onboarding-components": "static-1.1127",
  "customer-data-filters-ui": "static-1.41453",
  "customer-data-objects": "static-1.8214",
  "customer-data-reference-ui-components": "static-1.13678",
  "data-integrations-breeze": "static-1.383",
  "embedded-academy-lib": "static-1.16091",
  "ExportDialog": "static-6.10876",
  "global-styles-ai-lib": "static-1.550",
  "highcharts": "static-8.117",
  "highlight.js": "static-1.92",
  "marketplace-embed-ba": "static-1.951",
  "mermaid": "static-1.47",
  "react-colorpicker": "static-2.10712",
  "reporting-action-components": "static-1.42465",
  "reporting-data": "static-1.69467",
  "reporting-snowflake": "static-1.58083",
  "reporting-ui-components": "static-2.66736",
  "reporting-visualizations": "static-1.61541",
  "trellis-theming": "static-1.1519",
  "trial-components-library": "static-1.14430",
  "ui-addon-teams": "static-1.22043",
  "ui-addon-upgrades": "static-9.18567",
  "ui-universal-auth": "static-1.9796",
  "upgrade-components-lib": "static-1.763",
  "breeze-artifacts-sdk": "static-1.1079",
  "ably": "static-2.2",
  "batch-promise": "static-1.2053",
  "superstore": "static-1.5261",
  "magpie-types": "static-1.5392",
  "simple-logging-lib": "static-1.3554",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1223",
  "bend-plugin-pulse": "static-1.658",
  "event-emitter": "static-1.1464",
  "fast-json-patch": "static-1.76",
  "nudge-client-utils": "static-1.3462",
  "audio-components": "static-1.6611",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.24886",
  "FileManagerImages": "static-1.38037",
  "html-to-image": "static-1.67",
  "immerable": "static-1.4646",
  "redux-toolkit": "static-1.84",
  "reselect": "static-3.18",
  "salesImages": "static-1.760",
  "urlinator": "static-1.5017",
  "usage-tracker": "static-1.7825",
  "video-components": "static-1.14496",
  "video-data-lib": "static-1.36152",
  "redux-thunk": "static-2.86",
  "nav-meta": "static-1.30858",
  "getting-started-shared-tasks": "static-1.19612",
  "growth-data-modal": "static-1.6171",
  "growth-onboarding-confetti": "static-1.3561",
  "growth-onboarding-next-action-utils": "static-1.3033",
  "onboarding-tours-client": "static-1.5645",
  "onboarding-tours-utils": "static-1.1497",
  "ui-shepherd-react": "static-3.10785",
  "ui-shepherd-tracker": "static-1.8166",
  "user-context": "static-1.5558",
  "transmute": "static-2.97",
  "outpost": "static-1.4633",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "stylex-utils": "static-1.182",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10947",
  "amplitude-session-replay-browser": "static-1.60",
  "developer-experience-shared-components": "static-1.11045",
  "immutable-less": "static-1.5154",
  "marketplace-ui-client-types": "static-1.18485",
  "ui-addon-iframeable": "static-1.9582",
  "ui-addon-integrations-directory-panel": "static-2.8457",
  "ui-extensibility-client-types": "static-1.4418",
  "ai-settings-ui-library": "static-1.8635",
  "integrations-lib": "static-1.17487",
  "laboratory-lib": "static-3.7650",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1682",
  "cms-field-types": "static-1.5314",
  "content-icons-ui": "static-1.2484",
  "underscore": "static-1.8",
  "atom": "static-1.5575",
  "customer-data-ui-utilities": "static-1.10335",
  "property-translator": "static-1.5884",
  "reference-resolvers": "static-1.8687",
  "breeze-assistant-components": "static-1.2534",
  "onboarding-journeys-lib": "static-1.1293",
  "onboarding-scopes": "static-1.6956",
  "conversations-skeleton-state": "static-1.7621",
  "crm-message-bus": "static-1.44162",
  "customer-data-filters-ui-msw-helpers": "static-1.23888",
  "customer-data-property-utils": "static-1.8556",
  "events-data-lib": "static-1.751",
  "FormUrlGenerator": "static-2.5217",
  "framework-builder-read-service-client": "static-1.4350",
  "hs-resources": "static-1.689",
  "inbound-db-meta-service-client": "static-1.3789",
  "inbound-db-properties-service-client": "static-1.4165",
  "multi-account-reference-resolvers": "static-1.1517",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers-lite": "static-1.8618",
  "reporting-datasets-permissions-lib": "static-1.14816",
  "segments-client-types": "static-1.12273",
  "marketplace-embed": "static-1.23248",
  "marketplace-ui-install": "static-1.1064",
  "marketplace-ui-tracking": "static-1.15248",
  "content-assistance-lib": "static-1.8461",
  "dashboard-lib": "static-1.83371",
  "frontend-preferences-client": "static-1.8424",
  "hubspot-prosemirror": "static-1.19330",
  "hubspot-prosemirror-plugins": "static-1.19322",
  "prosemirror": "static-1.13",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "reporting-plugins": "static-1.11047",
  "rich-text-lib": "static-1.20597",
  "share-with-third-party-component-lib": "static-1.9214",
  "ui-addon-draggable": "static-3.5254",
  "ui-asset-management-lib": "static-1.11605",
  "ui-business-units-lib": "static-1.9601",
  "persist-promise": "static-1.4210",
  "reporting-client-types": "static-1.2862",
  "hubspot-apollo-client": "static-1.5385",
  "reporting-reports": "static-1.69143",
  "hs-promise-utils": "static-1.6094",
  "hubs-service-types": "static-1.1770",
  "merchandise-lib": "static-1.288",
  "purchase-motions-api": "static-1.6672",
  "purchase-motions-components": "static-1.6669",
  "custom-vendor-connection-lib": "static-1.360",
  "unified-auth-core-lib": "static-1.1592",
  "nudge-custom-function-registry": "static-1.3219",
  "nudge-renderer-utils": "static-1.3538",
  "whisper-core-api": "static-1.7676",
  "apollo-link-hub-http": "static-2.5092",
  "poll-commands": "static-1.3980",
  "video-components-external": "static-1.12494",
  "social-insights-client-types": "static-1.22977",
  "onboarding-data-sync-lib": "static-1.2876",
  "growth-onboarding-next-action-components": "static-1.3061",
  "user-context-client": "static-1.5012",
  "getting-started-shared-tasks-store": "static-1.18730",
  "apps-service-types": "static-1.4113",
  "oauth-service-types": "static-1.4639",
  "settings-ui-lib": "static-1.13031",
  "simple-data-table": "static-1.3867",
  "flux-actions": "static-1.383",
  "integrations-error-boundary-lib": "static-1.14902",
  "integrations-tracking-lib": "static-1.6126",
  "native-integrations-shared-strings": "static-1.8265",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10873",
  "rxjs": "static-5.10",
  "react-dnd-compat": "static-1.5111",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-sharing-core": "static-1.46",
  "restore-request-side-panel-lib": "static-1.2091",
  "conditional-properties-service-client": "static-1.4128",
  "crm-pipelines-api-client-types": "static-1.4458",
  "fdsr-migration-layer": "static-1.515",
  "multi-currency-client-types": "static-1.4023",
  "external-options-client-types": "static-1.4453",
  "crm-index-associations-lib": "static-1.6952",
  "connections-embed-lib": "static-1.1797",
  "fail-safe": "static-1.453",
  "ai-studio-lib": "static-1.12824",
  "integrations-reconnect-lib": "static-1.770",
  "ui-product-approvals": "static-1.29787",
  "ui-tool-access": "static-1.10661",
  "unified-auth": "static-1.1310",
  "ui-coaching-tips": "static-1.29612",
  "redux-actions": "static-3.76",
  "content-media-capture": "static-1.5838",
  "emoji-mart": "static-3.9",
  "growth-payments-core": "static-1.26551",
  "knowledge-content-types": "static-1.8767",
  "payment-link-components": "static-1.24512",
  "ui-addon-emoji-picker": "static-1.10367",
  "EmailSignatureEditor": "static-1.25294",
  "campaign-roi-lib": "static-1.10892",
  "campaigns-utils-lib": "static-1.3756",
  "ui-addon-calendars": "static-2.5871",
  "data-token-picker": "static-1.17178",
  "react-flip-move": "static-1.85",
  "nested-table": "static-1.730",
  "seat-types-lib": "static-1.1098",
  "timezone-utils": "static-2.5733",
  "hubspot-apollo-cache": "static-1.844",
  "codemirror": "static-5.108",
  "fsm": "static-1.4261",
  "react-codemirror": "static-1.11146",
  "content-media-composition-data-lib": "static-1.13642",
  "content-media-compositions": "static-2.17649",
  "media-bridge-lib": "static-1.19682",
  "InboxConnectUtils": "static-4.15889",
  "meetings-connect-utils-lib": "static-1.8123",
  "universal-page-editor-lib": "static-1.3516",
  "bend-plugin-fail-safe": "static-1.404",
  "property-management-iframe": "static-1.14520",
  "collaboration-sidebar": "static-1.59117",
  "trellis-ext-dnd": "static-1.585",
  "adobe-sign-auth-lib": "static-1.788",
  "ads-unified-auth-lib": "static-1.2154",
  "ai-mcp-auth-lib": "static-1.50",
  "gemini-settings-lib": "static-1.9832",
  "google-sheets-integration-lib": "static-1.1380",
  "microsoft-drive-auth-lib": "static-1.571",
  "slack-ui-library": "static-1.10903",
  "surveymonkey-integration-lib": "static-1.894",
  "growth-onboarding-feedback-components": "static-1.7084",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4933",
  "ui-addon-opt": "static-4.8922",
  "commerce-tours-lib": "static-1.6903",
  "customer-data-properties": "static-1.53139",
  "growth-onboarding-reliability": "static-1.5587",
  "sales-checkout-service-client": "static-1.4025",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22401",
  "sales-email-signature-service-client": "static-1.4351",
  "copilot-messaging": "static-1.2451",
  "ts-utils-lib": "static-1.655",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "js-cookie": "static-1.18",
  "hub-http-contrib": "static-1.3535",
  "ui-addon-sales-email": "static-1.5706",
  "crm-record-cards-client": "static-1.120",
  "crm-record-cards-service-types": "static-1.3876",
  "framework-data-schema-resolvers": "static-1.7396",
  "location-customization-utils-lib": "static-1.10474",
  "property-management-common": "static-1.6808",
  "chatspot-widget-iframe": "static-1.24037",
  "collaboration-sidebar-common": "static-1.3914",
  "marketing-platform-lib": "static-1.7411",
  "dnd-kit": "static-1.23",
  "commerce-products-lib": "static-1.10978",
  "calling-global-api": "static-1.66280",
  "calling-internal-common": "static-1.31827",
  "calling-lifecycle-internal": "static-1.67662",
  "calling-lifecycle-messages": "static-1.59954",
  "crm-index-visualization-core": "static-1.4796",
  "crm-links": "static-1.6817",
  "customer-data-properties-shared-msw-handlers": "static-1.10276",
  "data-agent-utils": "static-1.977",
  "formula-editor": "static-1.15047",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4529",
  "meetings-icalendar-utils-lib": "static-1.1135",
  "object-builder-ui-client": "static-1.50111",
  "pipeline-validation-client-types": "static-1.4298",
  "property-value-citations": "static-1.3753",
  "react-tinymce": "static-1.56318",
  "smart-data-capture-core": "static-1.538",
  "tiered-pricing": "static-1.2328",
  "tinymce-config": "static-2.55444",
  "tinymce-plugins": "static-1.58558",
  "tinymce-themes": "static-1.57414",
  "topics-actions-lib": "static-1.689",
  "trellis-ext-i18n": "static-1.1429",
  "ui-addon-form-validation": "static-1.11352",
  "framework-data-schema-quick-fetch": "static-1.7301",
  "crm-component-utils": "static-1.40264",
  "crm-properties-common-lib": "static-1.6401",
  "commerce-permissions": "static-1.1290",
  "customer-data-tracking": "static-1.7375",
  "products-iframe-lib": "static-1.8967",
  "products-ui-components-shared-msw-handlers": "static-1.11331",
  "calling-error-reporting": "static-1.31834",
  "shared-worker-versioning": "static-1.11546",
  "calling-usage-tracker": "static-1.7044",
  "voice-sms-access-library": "static-1.2536",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11032",
  "sales-views-client-types": "static-1.4761",
  "data-agent-kit": "static-1.964",
  "enrichment-settings-lib": "static-1.307",
  "policy-lib": "static-1.7309",
  "bark-lib": "static-1.17037",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "interframe": "static-3.5246",
  "tinymce-data": "static-1.41529",
  "layout-dnd-components": "static-1.13269",
  "layout-dnd-utils": "static-1.12244",
  "ui-brand-identity-lib": "static-1.17013",
  "NamespacedHubStyle": "static-2.9382",
  "commerce-subscription-lib": "static-1.38103",
  "crm-actions": "static-1.6892",
  "crm-cards-sdk": "static-1.45091",
  "calling-orchestration-schema": "static-1.37313",
  "react-reducer-toolkit": "static-1.16715",
  "ContentData": "static-1.69613",
  "layout-data-lib": "static-1.10569",
  "commerce-billing-lib": "static-1.20541",
  "commerce-shared-components-lib": "static-1.19625",
  "commerce-tools-ui-lib": "static-1.11374",
  "crm_data": "static-4.93262",
  "crm-activity-creator-data": "static-1.47809",
  "crm-fe-perf": "static-1.23402",
  "universal-record-utils-lib": "static-1.2420",
  "advanced-menus-core": "static-1.15860",
  "advanced-menus-lib": "static-1.12602",
  "ui-memberships-settings-lib": "static-1.35254",
  "utility-belt": "static-1.3041",
  "customer-data-associations": "static-1.7841",
  "framework-data-table": "static-2.12884",
  "payments-enrollment-embed-lib": "static-1.24289",
  "stripe-embedded-components": "static-1.8289",
  "customer-data-rte": "static-1.33947",
  "cv-backend-services": "static-1.1611",
  "growth-onboarding-empty-states": "static-1.6578",
  "payments-post-enroll-local-storage-lib": "static-1.5609",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39215",
  "crm_universal": "static-1.22766",
  "customer-data-email": "static-1.18684",
  "meetings-rte-lib": "static-1.587",
  "tasks-actions-lib": "static-1.486",
  "universal-associations-select": "static-1.11602",
  "crm-object-search-query-utilities": "static-1.10505",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15859",
  "simple-menus-lib": "static-1.17376",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29200",
  "sequences-lib": "static-1.8823",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4094",
  "meetings-core": "static-1.809",
  "sequences-client-types-lib": "static-1.8680"
},
  depPathPrefixes: {
  "academy-achievements-public-ui": "/academy-achievements-public-ui/static-1.1116",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.512",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8542",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "react-dlb": "/react-dlb/static-1.96",
  "academy-ai-assistant-lib": "/academy-ai-assistant-lib/static-1.1722",
  "academy-common-lib": "/academy-common-lib/static-1.15552",
  "academy-navigation-lib": "/academy-navigation-lib/static-1.2655",
  "analytics_js": "/analytics_js/static-1.4512",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "avatar-components": "/avatar-components/static-1.2991",
  "classnames": "/classnames/static-2.10",
  "data-fetching-client": "/data-fetching-client/static-1.10141",
  "enviro": "/enviro/static-4.523",
  "foundations-assets": "/foundations-assets/static-1.5393",
  "foundations-components": "/foundations-components/static-1.8792",
  "foundations-theming": "/foundations-theming/static-1.4993",
  "graphql": "/graphql/static-1.95",
  "hub-http": "/hub-http/static-1.6709",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11991",
  "I18n": "/I18n/static-7.1715",
  "quartz": "/quartz/static-1.7694",
  "quartz-config": "/quartz-config/static-1.1472",
  "quartz-core": "/quartz-core/static-1.6913",
  "quartz-routing": "/quartz-routing/static-1.1124",
  "quartz-tracking": "/quartz-tracking/static-1.1073",
  "raven": "/raven/static-3.6411",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17242",
  "rpc-client-utils": "/rpc-client-utils/static-1.5169",
  "signup-constants": "/signup-constants/static-1.19995",
  "styled-components": "/styled-components/static-2.100",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7892",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11648",
  "UIComponents": "/UIComponents/static-3.8937",
  "viral-links-lib": "/viral-links-lib/static-1.7586",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3971",
  "quartz-webpack": "/quartz-webpack/static-1.3918",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.772",
  "HeadJS": "/HeadJS/static-2.829",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3653",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.35",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10071",
  "ai-rendering-library": "/ai-rendering-library/static-1.11451",
  "breeze-engine-core": "/breeze-engine-core/static-1.1545",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1245",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2267",
  "copilot-toolkit": "/copilot-toolkit/static-1.12201",
  "hs-lodash": "/hs-lodash/static-4.45",
  "magpie-lib": "/magpie-lib/static-1.5932",
  "navigation-components": "/navigation-components/static-1.19221",
  "nest": "/nest/static-1.740",
  "pulse": "/pulse/static-1.1154",
  "storybook-react": "/storybook-react/static-1.46",
  "ts-schema": "/ts-schema/static-1.4409",
  "zustand": "/zustand/static-1.91",
  "academy-service-client": "/academy-service-client/static-1.4195",
  "croppie": "/croppie/static-2.10",
  "cssUtils": "/cssUtils/static-1.1125",
  "feedback-loader": "/feedback-loader/static-1.30102",
  "FileManagerCore": "/FileManagerCore/static-1.40385",
  "FileManagerLib": "/FileManagerLib/static-1.40526",
  "final-form": "/final-form/static-1.85",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1817",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2709",
  "hs-story-utils": "/hs-story-utils/static-1.9931",
  "HubStyle": "/HubStyle/static-2.12298",
  "icons": "/icons/static-2.709",
  "immer": "/immer/static-1.107",
  "markdown-it": "/markdown-it/static-1.6",
  "navigation-messaging": "/navigation-messaging/static-1.8548",
  "onboarding-tours": "/onboarding-tours/static-1.17430",
  "PatternValidationJS": "/PatternValidationJS/static-1.3385",
  "quick-fetch": "/quick-fetch/static-1.4245",
  "react-utils": "/react-utils/static-2.5681",
  "SafeStorage": "/SafeStorage/static-1.4898",
  "sanitize-text": "/sanitize-text/static-1.8661",
  "sassPrefix": "/sassPrefix/static-1.390",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10028",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9126",
  "ui-fonts": "/ui-fonts/static-1.1253",
  "ui-images": "/ui-images/static-2.1283",
  "usage-tracker-container": "/usage-tracker-container/static-1.7815",
  "usage-tracker-core": "/usage-tracker-core/static-1.7675",
  "video-embed": "/video-embed/static-1.36986",
  "wootric-nps": "/wootric-nps/static-1.7312",
  "hub-http-janus": "/hub-http-janus/static-1.913",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10949",
  "hubspotter-http": "/hubspotter-http/static-1.4989",
  "trellis-components": "/trellis-components/static-1.3179",
  "trellis-migration-context": "/trellis-migration-context/static-1.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5061",
  "floating-ui": "/floating-ui/static-1.70",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.111",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3160",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3476",
  "foundations-theming-base": "/foundations-theming-base/static-1.3978",
  "stylex": "/stylex/static-1.48",
  "hs-locale-management": "/hs-locale-management/static-1.416",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4809",
  "jasmine-runner": "/jasmine-runner/static-1.6956",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.295",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.670",
  "quartz-auth": "/quartz-auth/static-1.1369",
  "quartz-head": "/quartz-head/static-1.1359",
  "quartz-i18n": "/quartz-i18n/static-1.1369",
  "quartz-test": "/quartz-test/static-1.1369",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5511",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.202",
  "web-vitals": "/web-vitals/static-1.21",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.579",
  "chirp-fetch": "/chirp-fetch/static-1.2408",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19610",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21078",
  "trellis-story-utils": "/trellis-story-utils/static-1.5002",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6275",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8541",
  "bender-build-tools": "/bender-build-tools/static-1.3617",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24046",
  "ContentUtils": "/ContentUtils/static-1.69538",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13539",
  "sanitize": "/sanitize/static-1.4973",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1127",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41453",
  "customer-data-objects": "/customer-data-objects/static-1.8214",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13678",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.383",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16091",
  "ExportDialog": "/ExportDialog/static-6.10876",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.550",
  "highcharts": "/highcharts/static-8.117",
  "highlight.js": "/highlight.js/static-1.92",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.951",
  "mermaid": "/mermaid/static-1.47",
  "react-colorpicker": "/react-colorpicker/static-2.10712",
  "reporting-action-components": "/reporting-action-components/static-1.42465",
  "reporting-data": "/reporting-data/static-1.69467",
  "reporting-snowflake": "/reporting-snowflake/static-1.58083",
  "reporting-ui-components": "/reporting-ui-components/static-2.66736",
  "reporting-visualizations": "/reporting-visualizations/static-1.61541",
  "trellis-theming": "/trellis-theming/static-1.1519",
  "trial-components-library": "/trial-components-library/static-1.14430",
  "ui-addon-teams": "/ui-addon-teams/static-1.22043",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18567",
  "ui-universal-auth": "/ui-universal-auth/static-1.9796",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.763",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1079",
  "ably": "/ably/static-2.2",
  "batch-promise": "/batch-promise/static-1.2053",
  "superstore": "/superstore/static-1.5261",
  "magpie-types": "/magpie-types/static-1.5392",
  "simple-logging-lib": "/simple-logging-lib/static-1.3554",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1223",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.658",
  "event-emitter": "/event-emitter/static-1.1464",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "nudge-client-utils": "/nudge-client-utils/static-1.3462",
  "audio-components": "/audio-components/static-1.6611",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.24886",
  "FileManagerImages": "/FileManagerImages/static-1.38037",
  "html-to-image": "/html-to-image/static-1.67",
  "immerable": "/immerable/static-1.4646",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "reselect": "/reselect/static-3.18",
  "salesImages": "/salesImages/static-1.760",
  "urlinator": "/urlinator/static-1.5017",
  "usage-tracker": "/usage-tracker/static-1.7825",
  "video-components": "/video-components/static-1.14496",
  "video-data-lib": "/video-data-lib/static-1.36152",
  "redux-thunk": "/redux-thunk/static-2.86",
  "nav-meta": "/nav-meta/static-1.30858",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19612",
  "growth-data-modal": "/growth-data-modal/static-1.6171",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3561",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3033",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5645",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1497",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10785",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8166",
  "user-context": "/user-context/static-1.5558",
  "transmute": "/transmute/static-2.97",
  "outpost": "/outpost/static-1.4633",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "stylex-utils": "/stylex-utils/static-1.182",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10947",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11045",
  "immutable-less": "/immutable-less/static-1.5154",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18485",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9582",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8457",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4418",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8635",
  "integrations-lib": "/integrations-lib/static-1.17487",
  "laboratory-lib": "/laboratory-lib/static-3.7650",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1682",
  "cms-field-types": "/cms-field-types/static-1.5314",
  "content-icons-ui": "/content-icons-ui/static-1.2484",
  "underscore": "/underscore/static-1.8",
  "atom": "/atom/static-1.5575",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10335",
  "property-translator": "/property-translator/static-1.5884",
  "reference-resolvers": "/reference-resolvers/static-1.8687",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2534",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1293",
  "onboarding-scopes": "/onboarding-scopes/static-1.6956",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7621",
  "crm-message-bus": "/crm-message-bus/static-1.44162",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23888",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8556",
  "events-data-lib": "/events-data-lib/static-1.751",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5217",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4350",
  "hs-resources": "/hs-resources/static-1.689",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3789",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4165",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1517",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8618",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14816",
  "segments-client-types": "/segments-client-types/static-1.12273",
  "marketplace-embed": "/marketplace-embed/static-1.23248",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1064",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15248",
  "content-assistance-lib": "/content-assistance-lib/static-1.8461",
  "dashboard-lib": "/dashboard-lib/static-1.83371",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8424",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19330",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19322",
  "prosemirror": "/prosemirror/static-1.13",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "reporting-plugins": "/reporting-plugins/static-1.11047",
  "rich-text-lib": "/rich-text-lib/static-1.20597",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9214",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5254",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11605",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9601",
  "persist-promise": "/persist-promise/static-1.4210",
  "reporting-client-types": "/reporting-client-types/static-1.2862",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5385",
  "reporting-reports": "/reporting-reports/static-1.69143",
  "hs-promise-utils": "/hs-promise-utils/static-1.6094",
  "hubs-service-types": "/hubs-service-types/static-1.1770",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "purchase-motions-api": "/purchase-motions-api/static-1.6672",
  "purchase-motions-components": "/purchase-motions-components/static-1.6669",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.360",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1592",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3219",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3538",
  "whisper-core-api": "/whisper-core-api/static-1.7676",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5092",
  "poll-commands": "/poll-commands/static-1.3980",
  "video-components-external": "/video-components-external/static-1.12494",
  "social-insights-client-types": "/social-insights-client-types/static-1.22977",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2876",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3061",
  "user-context-client": "/user-context-client/static-1.5012",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18730",
  "apps-service-types": "/apps-service-types/static-1.4113",
  "oauth-service-types": "/oauth-service-types/static-1.4639",
  "settings-ui-lib": "/settings-ui-lib/static-1.13031",
  "simple-data-table": "/simple-data-table/static-1.3867",
  "flux-actions": "/flux-actions/static-1.383",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14902",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6126",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8265",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10873",
  "rxjs": "/rxjs/static-5.10",
  "react-dnd-compat": "/react-dnd-compat/static-1.5111",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.46",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2091",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4128",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4458",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.515",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4023",
  "external-options-client-types": "/external-options-client-types/static-1.4453",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6952",
  "connections-embed-lib": "/connections-embed-lib/static-1.1797",
  "fail-safe": "/fail-safe/static-1.453",
  "ai-studio-lib": "/ai-studio-lib/static-1.12824",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.770",
  "ui-product-approvals": "/ui-product-approvals/static-1.29787",
  "ui-tool-access": "/ui-tool-access/static-1.10661",
  "unified-auth": "/unified-auth/static-1.1310",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29612",
  "redux-actions": "/redux-actions/static-3.76",
  "content-media-capture": "/content-media-capture/static-1.5838",
  "emoji-mart": "/emoji-mart/static-3.9",
  "growth-payments-core": "/growth-payments-core/static-1.26551",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "payment-link-components": "/payment-link-components/static-1.24512",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10367",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25294",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10892",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3756",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5871",
  "data-token-picker": "/data-token-picker/static-1.17178",
  "react-flip-move": "/react-flip-move/static-1.85",
  "nested-table": "/nested-table/static-1.730",
  "seat-types-lib": "/seat-types-lib/static-1.1098",
  "timezone-utils": "/timezone-utils/static-2.5733",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.844",
  "codemirror": "/codemirror/static-5.108",
  "fsm": "/fsm/static-1.4261",
  "react-codemirror": "/react-codemirror/static-1.11146",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13642",
  "content-media-compositions": "/content-media-compositions/static-2.17649",
  "media-bridge-lib": "/media-bridge-lib/static-1.19682",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15889",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8123",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3516",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.404",
  "property-management-iframe": "/property-management-iframe/static-1.14520",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59117",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.585",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2154",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.50",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9832",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1380",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
  "slack-ui-library": "/slack-ui-library/static-1.10903",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.894",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7084",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4933",
  "ui-addon-opt": "/ui-addon-opt/static-4.8922",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6903",
  "customer-data-properties": "/customer-data-properties/static-1.53139",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5587",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4025",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22401",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4351",
  "copilot-messaging": "/copilot-messaging/static-1.2451",
  "ts-utils-lib": "/ts-utils-lib/static-1.655",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "js-cookie": "/js-cookie/static-1.18",
  "hub-http-contrib": "/hub-http-contrib/static-1.3535",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5706",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.120",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3876",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7396",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10474",
  "property-management-common": "/property-management-common/static-1.6808",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24037",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3914",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7411",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-products-lib": "/commerce-products-lib/static-1.10978",
  "calling-global-api": "/calling-global-api/static-1.66280",
  "calling-internal-common": "/calling-internal-common/static-1.31827",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67662",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59954",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4796",
  "crm-links": "/crm-links/static-1.6817",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10276",
  "data-agent-utils": "/data-agent-utils/static-1.977",
  "formula-editor": "/formula-editor/static-1.15047",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4529",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1135",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50111",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4298",
  "property-value-citations": "/property-value-citations/static-1.3753",
  "react-tinymce": "/react-tinymce/static-1.56318",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.538",
  "tiered-pricing": "/tiered-pricing/static-1.2328",
  "tinymce-config": "/tinymce-config/static-2.55444",
  "tinymce-plugins": "/tinymce-plugins/static-1.58558",
  "tinymce-themes": "/tinymce-themes/static-1.57414",
  "topics-actions-lib": "/topics-actions-lib/static-1.689",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1429",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7301",
  "crm-component-utils": "/crm-component-utils/static-1.40264",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6401",
  "commerce-permissions": "/commerce-permissions/static-1.1290",
  "customer-data-tracking": "/customer-data-tracking/static-1.7375",
  "products-iframe-lib": "/products-iframe-lib/static-1.8967",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11331",
  "calling-error-reporting": "/calling-error-reporting/static-1.31834",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11546",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7044",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2536",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11032",
  "sales-views-client-types": "/sales-views-client-types/static-1.4761",
  "data-agent-kit": "/data-agent-kit/static-1.964",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.307",
  "policy-lib": "/policy-lib/static-1.7309",
  "bark-lib": "/bark-lib/static-1.17037",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5246",
  "tinymce-data": "/tinymce-data/static-1.41529",
  "layout-dnd-components": "/layout-dnd-components/static-1.13269",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12244",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17013",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9382",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38103",
  "crm-actions": "/crm-actions/static-1.6892",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45091",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37313",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16715",
  "ContentData": "/ContentData/static-1.69613",
  "layout-data-lib": "/layout-data-lib/static-1.10569",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20541",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19625",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11374",
  "crm_data": "/crm_data/static-4.93262",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47809",
  "crm-fe-perf": "/crm-fe-perf/static-1.23402",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2420",
  "advanced-menus-core": "/advanced-menus-core/static-1.15860",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12602",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35254",
  "utility-belt": "/utility-belt/static-1.3041",
  "customer-data-associations": "/customer-data-associations/static-1.7841",
  "framework-data-table": "/framework-data-table/static-2.12884",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24289",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8289",
  "customer-data-rte": "/customer-data-rte/static-1.33947",
  "cv-backend-services": "/cv-backend-services/static-1.1611",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6578",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5609",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39215",
  "crm_universal": "/crm_universal/static-1.22766",
  "customer-data-email": "/customer-data-email/static-1.18684",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.587",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.486",
  "universal-associations-select": "/universal-associations-select/static-1.11602",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10505",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15859",
  "simple-menus-lib": "/simple-menus-lib/static-1.17376",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29200",
  "sequences-lib": "/sequences-lib/static-1.8823",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4094",
  "meetings-core": "/meetings-core/static-1.809",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8680"
}
};
